import type { SVGProps } from 'react';
import * as React from 'react';

const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="outline/check">
      <path
        id="Icon"
        d="M4.5 12.75L9.75 18L19.5 5.25"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default CheckIcon;
